import { render, staticRenderFns } from "./BankHeader.vue?vue&type=template&id=a6e44ba6&scoped=true"
import script from "./BankHeader.vue?vue&type=script&lang=js"
export * from "./BankHeader.vue?vue&type=script&lang=js"
import style0 from "./BankHeader.vue?vue&type=style&index=0&id=a6e44ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e44ba6",
  null
  
)

export default component.exports